// extracted by mini-css-extract-plugin
export default {"page":"ZX-z","cartModal":"_X-z","checkout":"aY-z","placeholder":"bY-z","account":"cY-z"};